/**
 * @Desription: 授权码管理器
 * @Author: netstar.sjj
 * @Date: 2021-10-26 11:05:00
 * @class NSOAuthCode
*/
declare const window:any;
namespace NSOAuthCode{
    export const isWaitingRefreshToken:boolean = false; 	//是否在等待刷新token，为了防止多次刷新，所以
    /**
     * 用于控制登录范围和过期时间
     * @returns 
     * {
     * 	expires: new Date(),
     * 	path: 'http://localhost/erp'
     * }
     */
    export function getExpires(expireTime:any) {
        let obj:any = {};
        let expiresDate:any = new Date();
        expiresDate.setTime(expiresDate.getTime() + expireTime);
        obj.expires = expiresDate.getTime();
        let href = window.location.href;
        let path = href.substring(0, href.lastIndexOf('/'));
        obj.path = path;
        return obj;
    }
    //保存授权码
    /* {
    *	authorization:'',  				//string, 	token 
    *	expireMinute:120,  				//number, 	超时时长，单位为分钟
    *	loginTimeStamp:1567047626704, 	//number, 	仅在登录时候有值
    * }
    */
    export function set(authorObj:any) {
        let code:any = authorObj.authorization;
        let expireTime:any = authorObj.expireMinute * 60 * 1000; //由分钟转化为毫秒
        let expires:any = window.NSUtils.OAuthCode.getExpires(expireTime);  //过期时间和路径
        let currentDate:any = new Date();
        let currentTS:any = currentDate.getTime();
        let currentDateString:any = currentDate.toString();
        let oAuthInfo:any = {
            code: code,
            lastOperate: currentTS, 				//时间戳 最后一次操作时间
            expires: expires.expires, 		//时间戳 过期时间
            path: expires.path, 			//path
            dateTimeLastOperate: currentDateString,
            dateTimeExpires: new Date(expires.expires).toString(),
        };
        //如果有登录时间戳，则保存
        if (authorObj.loginTimeStamp) {
            let loginInfo:any = {
                timeStamp: authorObj.loginTimeStamp,
                date: new Date(authorObj.loginTimeStamp).toString(),
                expireMinute: authorObj.expireMinute
            };
            window.store.set('NetstarLoginExpiresInfo',loginInfo);
            window.NSUtils.OAuthCode.saveTokenLog('login');
        }
        window.store.set('Authorization', oAuthInfo);
    }
    //定时刷新token
    export function refreshToken(){
        let NSSystemConfig:any = window.NSSystemConfig;
        let url:string = window.NSUtils.getUrl({urlType: 'api',suffix: '/refreshToken'});
        let type:string = NSSystemConfig.refreshToken.ajax.type ? NSSystemConfig.refreshToken.ajax.type : "POST";
        if(NSSystemConfig.refreshToken){
            url = window.NSUtils.getUrl({urlType: 'api',suffix: NSSystemConfig.refreshToken.ajax.url}); 
        }
        if(typeof(window.NetstarApiConfig)=='object'){
            if(window.NetstarApiConfig.refreshTokenAjax){
                url = window.NetstarApiConfig.refreshTokenAjax;
            }
        }
        window.NSUtils.OAuthCode.saveTokenLog('ready-to-refresh');
        window.jQuery.ajax({
            cache: false,
            type: type,
            url: url,
            contentType:'application/json',
            headers: {
                Authorization: window.NSUtils.OAuthCode.get(),
            },
            data: {},
            success: function (data:any, textStatus:any, request:any) {
                let token:any = request.getResponseHeader('Authorization');
                if (typeof (token) != 'string') {
                    let errorInfo:string = window.language.refreshToken.fail;
                    console.error(errorInfo, request.getAllResponseHeaders());
                    return;
                }
                let expiresInfo:any = window.NSUtils.OAuthCode.getExpiresInfo();
                let tokenInfo = {
                    authorization: token,
                    expireMinute: expiresInfo.expireMinute,
                };
                window.NSUtils.OAuthCode.set(tokenInfo);
                window.NSUtils.OAuthCode.saveTokenLog('success-to-refresh');
                window.NSUtils.reEntryDialog.clearTimeoutFun();
            },
            error: function (error:any) {
                window.NSUtils.defaultAjaxError(error);
            },
            complete: function () {
                //重置是否等待刷新标识，等待下次刷新
                window.NSUtils.OAuthCode.isWaitingRefreshToken = false;
                if(typeof(window.NetStarUtils) == "object" && typeof(window.NetStarUtils.OAuthCode) == "object"){
                    window.NetStarUtils.OAuthCode.isWaitingRefreshToken = false;
                }
            }
        });
    }
    //保存刷新token的日志
    export function saveTokenLog(saveType:string) {
        let currentDate:any = new Date();
        let saveInfo:any = {
            type: saveType,
            timeStamp: currentDate.getTime(),
            date: currentDate.toString(),
        };
        let logs:any = window.store.get('NetstarTokenLog');
        //没有则新建，有则限制长度，最长20条，防止超长
        if (typeof (logs) != 'object') {
            logs = [];
        }
        while (logs.length > 20) {
            logs.splice(logs.length - 1, 1);
        }
        logs.unshift(saveInfo);
        window.store.set('NetstarTokenLog', logs);
    }
    //返回授权码
    export function get(){
        /*
            * 验证是否需要获取token NetstarHomeConfig.isNeedToken==true(需要)否则(不需要))
            * 不需要登录时不需要获取token 获取假的token : default
            * isNeedToken 存在登录页时配置在登录页上 否则配置在开始页面
        */
        if (typeof (window.NetstarHomeConfig) == "object" && window.NetstarHomeConfig.isNeedToken === false) {
            return 'default';
        }
        let oAuthInfo:any = window.store.get('Authorization');
        if (typeof (oAuthInfo) != 'object') {
            //不合法字符同样返回失败
            return false;
        }
        let currentTS:any = new Date().getTime();
        if (currentTS > oAuthInfo.expires) {
            window.NSUtils.OAuthCode.clear()
            //token超期
            if(typeof(window.NetstarApiConfig.timeOutBackPageUrl) == 'string'){
                // 北京联通项目，登录超时需要跳转到登录页面
                var timeOutBackPageUrl = window.NetstarApiConfig.webRootPath + window.NetstarApiConfig.timeOutBackPageUrl;
                window.location = timeOutBackPageUrl;
            }
            console.log(window.language.login.expireToken);
            //console.error(window.NSLanguage.language.login.expireToken);
            return false;
        }
        //如果超时时间不足60分钟，则重新获取token 延迟2秒后刷新
        if((oAuthInfo.expires - currentTS) / 1000 / 60 <= 2 && window.NSUtils.OAuthCode.isWaitingRefreshToken == false) {
            // window.NSUtils.OAuthCode.isWaitingRefreshToken = true;
            // setTimeout(function () {
            //     window.NSUtils.OAuthCode.refreshToken();
            // },2000)
            if(typeof(window.NetStarUtils) == "object" && typeof(window.NetStarUtils.OAuthCode) == "object"){
                if(window.NetStarUtils.OAuthCode.isWaitingRefreshToken == false){
                    window.NSUtils.OAuthCode.isWaitingRefreshToken = true;
                    window.NetStarUtils.OAuthCode.isWaitingRefreshToken = true;
                    setTimeout(function () {
                        window.NSUtils.OAuthCode.refreshToken();
                    },2000)
                }
            }else{
                window.NSUtils.OAuthCode.isWaitingRefreshToken = true;
                setTimeout(function () {
                    window.NSUtils.OAuthCode.refreshToken();
                },2000)
            }
        }

        //返回授权码则更新最后操作时间
        let lastOperateDate:any = new Date();
        let lastOperate:any = lastOperateDate.getTime();
        let dateTimeLastOperate:string = lastOperateDate.toString();
        oAuthInfo.lastOperate = lastOperate;
        oAuthInfo.dateTimeLastOperate = dateTimeLastOperate;
        window.store.set('Authorization', oAuthInfo);
        let code = oAuthInfo.code;
        return code;
    }
    export function getExpiresInfo() {
        let expiresInfo:any = window.store.get('NetstarLoginExpiresInfo');
        return expiresInfo;
    }
    //获取储存的信息
    export function getStoreInfo() {
        let infoObj:any = window.store.get('Authorization');
        return infoObj;
    }
    //清除授权信息，用于退出登录状态
    export function clear() {
        window.store.set('Authorization','false');
    }
    //重新登录
    export function reLogin() {
        //先临时写成了跳转到登录页
        window.NSUtils.reEntryDialog.init(0);
    }
    export function signin(formData:any, callbackFunc:Function) {
        formData.login = 1;
        let urlParams:any = window.NSUtils.getUrlPara();
        if (typeof (urlParams) == 'object') {
            window.jQuery.each(urlParams, function (key:string, value:any) {
                switch (key) {
                    case 'callback':
                        //callback是一个json文本 需要decode 例如 %257B%2522customerId%2522:1310336379963573234%257D  => {"customerId":1310336379963573234}
                        formData[key] = decodeURIComponent(value);
                        break;
                    default:
                        break;
                }
            });
        }
        let _config:any = window.NetstarHomeConfig.loginConfig;
        window.jQuery.ajax({
            type: "POST",
            dataType: 'json',
            url: _config.loginAjax.url,
            data: formData,
            plusData: {
                callbackFunc: callbackFunc,
            },
            success: function (res:any) {
                /**
                * res:{
                *  success:true,
                *  data:'eyJ0eXA...'   //返回的data就是token
                * }
                */
                if (res.success) {
                    //登录成功后请求用户消息并登录系统  
                    if (typeof (res.data) != 'string') {
                        console.error(window.language.login.ajaxReturnToken);
                        return;
                    }
                    let params:any = window.location.search.slice(1).split('&');
                    let result:any = {};
                    for (let i = 0; i < params.length; i++) {
                        let idx = params[i].indexOf('=');
                        if (idx > 0) {
                            result[params[i].substring(0, idx)] = params[i].substring(idx + 1);
                        }
                    }
                    window.NSLogin.serverData = res;
                    window.NSLogin.Authorization = window.NSLogin.serverData.data;

                    //保存授权码
                    window.NSUtils.OAuthCode.set({
                        authorization: window.NSLogin.Authorization,
                        expireMinute: _config.expireMinute,
                        loginTimeStamp: new Date().getTime(),
                    });
                    let plusData = this.plusData;
                    if (typeof (plusData.callbackFunc) == "function") {
                        plusData.callbackFunc();
                    }
                    // 登录即时器
                    if (window.NSUtils.OAuthCode.loginTimer) {
                        clearTimeout(window.NSUtils.OAuthCode.loginTimer);
                    }
                    window.NSUtils.OAuthCode.loginTimer = setTimeout(function () {
                        // 北京联通H5登录超时跳转到登录页面
                        window.NSUtils.OAuthCode.clear();
                        if(typeof(window.NetstarApiConfig.timeOutBackPageUrl) == 'string'){
                            let timeOutBackPageUrl:string = window.NetstarApiConfig.timeOutBackPageUrl;
                            window.location = window.location.origin + timeOutBackPageUrl;
                        }else {
                            window.NSUtils.OAuthCode.reLoginDialog();
                        }
                        
                    }, _config.expireMinute * 60 * 60 * 1000)
                } else {
                    window.nsalert(res.pwmsg);//不成功提示错误 如密码错误等
                }
            },
            error: window.NSLogin.ajaxError,
        });
    }
    export function reLoginDialog() {
        let dialogConfig:any = {
            id: "netstar-re-login",
            width: 300,
            height: 172,
            title: '超时登录',
            templateName: 'PC',
            isAllowDrag: false,
            shownHandler: function (data:any) {
                let dialogBodyId:string = data.config.bodyId;
                let footerIdGroup:string = data.config.footerIdGroup;
                let html:string = '<div class="pt-btn-group">'
                                        + '<button class="pt-btn pt-btn-default" ns-type="signin">'+window.language.common.nsalert.login+'</button>'
                                        + '<button class="pt-btn pt-btn-default" ns-type="close">'+window.language.common.nsalert.cancel+'</button>'
                                    + '</div>';
                let $html:any = window.jQuery(html);
                let $btns:any = $html.children('button');
                $btns.off('click');
                $btns.on('click', function () {
                    let $this:any = window.jQuery(this);
                    let nsType:string = $this.attr('ns-type');
                    switch (nsType) {
                        case 'signin':
                            let formData:any = window.NetstarComponent.getValues(dialogBodyId);
                            window.NSUtils.OAuthCode.signin(formData, function () {
                                window.NetstarComponent.dialog["netstar-re-login"].vueConfig.close();
                            });
                            break;
                        case 'close':
                            window.NetstarComponent.dialog["netstar-re-login"].vueConfig.close();
                            break;
                    }
                });
                window.jQuery('#' + footerIdGroup).append($html);
                let formJson:any = {
                    id: dialogBodyId,
                    templateName: 'form',
                    componentTemplateName: 'PC',
                    defaultComponentWidth: '100%',
                    isSetMore: false,
                    form: [
                        {
                            id: 'username',
                            label: '用户名',
                            type: 'text',
                            rules: 'required',
                        }, {
                            id: 'password',
                            label: '密码',
                            type: 'password',
                            rules: 'required',
                        }
                    ],
                };
                window.NetstarComponent.formComponent.show(formJson);
            },
        }
        window.NetstarComponent.dialogComponent.init(dialogConfig);
    }
}
export default NSOAuthCode;